import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays variant-aware product metafield accordions.
 * Listens for variant update events and morphs its contents from the
 * re-rendered section HTML.
 *
 * @extends {Component}
 */
class ProductMetafieldDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#updateContent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#updateContent);
  }

  /**
   * @param {CustomEvent} event - The variant update event.
   */
  #updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `product-metafield-details[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    morph(this, newElement);
  };
}

if (!customElements.get('product-metafield-details')) {
  customElements.define('product-metafield-details', ProductMetafieldDetails);
}
